@use 'vars';

.iq-menu-container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: vars.$border-size-thin solid vars.$mid-grey;

  &--compact {
    padding-bottom: vars.$padding-xsmall;
    .iq-menu-container-header--title {
      font-size: vars.$font-size-small;
    }
  }

  &--comfortable {
    padding-bottom: vars.$padding-small;
    .iq-menu-container-header--title {
      font-size: vars.$font-size-normal;
    }
  }

  &__title {
    display: flex;
    gap: vars.$gap-xsmall;
    font-weight: vars.$font-weight-bold;
    color: vars.$ai-primary;

    &--container {
      display: flex;
      align-items: center;
      gap: vars.$gap-small;
    }
  }

  &__action-title {
    font-weight: vars.$font-weight-bold;
  }
}
